import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
    fyStatus : false,
}

const fySettingsSlice = createSlice({
    name:'FinancialYear',
    initialState:INITIAL_STATE,
    reducers : {
        fySettingsOpen : (state) => {
            state.fyStatus = true
        },
        fySettingsfalse : (state) => {
            state.fyStatus = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
      },
})

export const {fySettingsOpen , fySettingsfalse} = fySettingsSlice.actions;
export default fySettingsSlice.reducer;